<template>
  <div
    class="container page bottom-offset4"
    :class="classes || ''"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'TrPage',
  props: ['classes']
};
</script>